import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;

    meta: any;
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,

    meta: {},
};

const initState = JSON.parse(JSON.stringify(state));

export const EMPLOYEE_DATA = 'GET_EMPLOYEE_DATA';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, params) {
        const vm = (this as any)._vm;

        if (params.id == 'new') {
            state.document = {};
            state.loaded = true
        } else {
            return new Promise((resolve, reject) => {
                if (!params.silence) {
                    commit('START_LOADING');
                }

                const columns: any = {
                    id: 'employee.id',
                    created_at: 'employee.created_at',
                    updated_at: 'employee.updated_at',

                    name: 'employee.name',

                    birthday: 'employee.birthday',
                    sex: 'employee.sex',
                    works_since: 'employee.works_since',

                    credentials: 'employee.credentials',

                    department_id: 'employee.department_id',
                    department_name: 'department.name',

                    position_id: 'employee.position_id',
                    position_name: 'position.name',

                    contacts: 'employee.contacts',
                    fired_at: 'employee.fired_at'
                };

                vm.$db([
                    vm.$q(EMPLOYEE_DATA)
                    .raw('documents.list')
                    .action({
                        columns,
                        from: 's:employees',
                        from_as: 'employee',
                        joins: [
                        {
                            join: 's:positions',
                            type: 'left',
                            as:   'position',
                            on: {
                            $eq: ['position.id', 'employee.position_id']
                            }
                        },
                        {
                            join: 's:departments',
                            type: 'left',
                            as:   'department',
                            on: {
                            $eq: ['department.id', 'employee.department_id']
                            }
                        },
                        ],
                        where: {
                            $eq: [`employee.id`, {$: params.id}]
                        }
                    })
                ]).then(((result: ServerResult) => {
                    commit('SET_EMPLOYEE_DATA', result.getOperation(EMPLOYEE_DATA).getContent());

                    if (!params.silence) {
                        commit('LOADED_SUCCESS');
                    }

                    resolve();
                }));
            })
        }
    },
};

export const mutations: MutationTree<WorkPlanBoardState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = initState[key]
        }
    },
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_EMPLOYEE_DATA(state, data) {
        const schema = data.schema;
        const document = data.documents[0];

        const contactsField = schema.fields.find((field: any) => field.code == 'contacts');

        if (contactsField) {
          state.meta.contacts = { types: {} };

          for (const _type of contactsField.meta.types) {
            state.meta.contacts.types[_type.value] = _type.label;

            if(_type.type_extras) {
                for(const extraType of _type.type_extras) {
                    state.meta.contacts.types[_type.value + extraType.value] = `${_type.label} / ${extraType.label}`;
                }
            }
          }
        }

        const sexField = schema.fields.find((field: any) => field.code == 'sex');

        if (sexField) {
          state.meta.sex = { choices: {} };

          for (const _type of sexField.meta.choices) {
            state.meta.sex.choices[_type.value] = _type.label;
          }
        }


        // const fieldMap = schema.fields.reduce((prev: any, field: any) => {
        //     prev[field.code] = field;
        //     return prev;
        // }, {});

        // const types: any[] = [];
        // const typesMap: any = {};

        // for(const type of fieldMap.contacts.meta.types) {
        //     const _type = {
        //       label: type.label,
        //       type: type.value,
        //     }

        //     types.push(_type)
        //     typesMap[type.value] = _type;

        //     if(type.type_extras) {
        //       for(const extraType of type.type_extras) {
        //         const _type = {
        //           label: `${type.label} / ${extraType.label}`,
        //           type: type.value,
        //           type_extra: extraType.value
        //         }

        //         types.push(_type)
        //         typesMap[type.value + extraType.value] = _type;
        //       }
        //     }
        // }

        // document.contacts = document.contacts.map((contact: any) => {
        //     return {
        //         ...contact,
        //         typeLabel: typesMap[contact.type + (contact.type_extra || '')].label
        //     }
        // })

        console.log(document)
        state.document = document
    },
};

const getters = {

};

export const STORE_KEY = '$_employee_details';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
